import { useEffect } from "react";

export const usePageMeta = (title, description) => {
  useEffect(() => {
    const prevTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const canonical = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonical?.getAttribute("href");
    const prevDesc = meta?.getAttribute("content");
    document.title = title;
    if (meta) meta.setAttribute("content", description);
    if (canonical) canonical.setAttribute("href", `https://kennethcarsoninsurance.com${window.location.pathname}`);
    window.scrollTo(0, 0);
    return () => {
      document.title = prevTitle;
      if (meta && prevDesc) meta.setAttribute("content", prevDesc);
      if (canonical && prevCanonical) canonical.setAttribute("href", prevCanonical);
    };
  }, [title, description]);
};
